module.exports = "<div class=\"kl-crumb f-cb {class}\">\n    {#inc this.$body}\n</div>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/navigation/KLCrumb/index.html
// module id = 513
// module chunks = 0